import { formatHeroCurrency } from './simpleProductPageShared';

export const PRICE_FIRST_PDP_SLUGS = Object.freeze([
  'livescope-2-lvs42hd',
  'livescope-2-lvs44',
  'livescope-2-lvs42hd-ice',
  'livescope-plus-lvs34',
  'livescope-plus-lvs34-ice',
  'garmin-lvs34',
]);

export const PDP_AFFILIATE_DISCLOSURE =
  'Angler Built may earn a commission when you purchase through retailer links, at no additional cost to you.';

export const PDP_AMAZON_ASSOCIATE_NOTE =
  'As an Amazon Associate, I earn from qualifying purchases. That disclosure is sitewide and does not mean Amazon currently offers this product here.';

const LVS42HD_ESCAPES = Object.freeze([
  {
    id: 'range',
    prompt: 'Need more range?',
    label: 'Compare LVS42HD vs LVS44',
    to: '/comparisons/lvs42hd-vs-lvs44',
    destination: 'comparison',
    cta: 'compare_lvs42hd_vs_lvs44',
  },
  {
    id: 'upgrade',
    prompt: 'Already own LVS34?',
    label: 'See if LVS42HD is worth the upgrade',
    to: '/comparisons/lvs34-vs-lvs42hd',
    destination: 'upgrade_comparison',
    cta: 'upgrade_lvs34_vs_lvs42hd',
  },
  {
    id: 'compatibility',
    prompt: 'Check compatibility',
    label: 'Check your Garmin screen',
    to: '/compatibility',
    destination: 'compatibility',
    cta: 'check_compatibility',
  },
  {
    id: 'ice',
    prompt: 'Building a dedicated ice setup?',
    label: 'See LVS42HD-IF',
    to: '/simple-products/livescope-2-lvs42hd-ice',
    destination: 'ice_variant',
    cta: 'see_lvs42hd_if',
  },
]);

const LVS44_ESCAPES = Object.freeze([
  {
    id: 'detail',
    prompt: 'Want maximum close-range detail?',
    label: 'Compare LVS42HD vs LVS44',
    to: '/comparisons/lvs42hd-vs-lvs44',
    destination: 'comparison',
    cta: 'compare_lvs42hd_vs_lvs44',
  },
  {
    id: 'upgrade',
    prompt: 'Already own LVS34?',
    label: 'See if LVS44 is worth the upgrade',
    to: '/comparisons/lvs34-vs-lvs44',
    destination: 'upgrade_comparison',
    cta: 'upgrade_lvs34_vs_lvs44',
  },
  {
    id: 'compatibility',
    prompt: 'Check compatibility',
    label: 'Check your Garmin screen',
    to: '/compatibility',
    destination: 'compatibility',
    cta: 'check_compatibility',
  },
]);

const LVS42HD_IF_ESCAPES = Object.freeze([
  {
    id: 'compare',
    prompt: 'Comparing LiveScope 2 options?',
    label: 'Compare LVS42HD / LVS42HD-IF / LVS44',
    to: '/comparisons/lvs42hd-vs-lvs44',
    destination: 'comparison',
    cta: 'compare_lvs42hd_if_family',
  },
  {
    id: 'standard',
    prompt: 'Need the boat or open-water package?',
    label: 'See standard LVS42HD',
    to: '/simple-products/livescope-2-lvs42hd',
    destination: 'standard_pdp',
    cta: 'see_standard_lvs42hd',
  },
  {
    id: 'compatibility',
    prompt: 'Check your Garmin screen',
    label: 'Check compatibility',
    to: '/compatibility',
    destination: 'compatibility',
    cta: 'check_compatibility',
  },
]);

const LVS34_SYSTEM_ESCAPES = Object.freeze([
  {
    id: 'upgrade-hd',
    prompt: 'Want a lighter HD upgrade?',
    label: 'See if LVS42HD is worth the upgrade',
    to: '/comparisons/lvs34-vs-lvs42hd',
    destination: 'upgrade_comparison',
    cta: 'upgrade_lvs34_vs_lvs42hd',
  },
  {
    id: 'upgrade-range',
    prompt: 'Need more range?',
    label: 'See if LVS44 is worth the upgrade',
    to: '/comparisons/lvs34-vs-lvs44',
    destination: 'upgrade_comparison',
    cta: 'upgrade_lvs34_vs_lvs44',
  },
  {
    id: 'compatibility',
    prompt: 'Check compatibility',
    label: 'Check your Garmin screen',
    to: '/compatibility',
    destination: 'compatibility',
    cta: 'check_compatibility',
  },
  {
    id: 'ice',
    prompt: 'Building a dedicated ice setup?',
    label: 'See the LVS34-IF ice system',
    to: '/simple-products/livescope-plus-lvs34-ice',
    destination: 'ice_variant',
    cta: 'see_lvs34_if',
  },
]);

const LVS34_ICE_ESCAPES = Object.freeze([
  {
    id: 'standard',
    prompt: 'Need the boat or open-water package?',
    label: 'See the standard LiveScope Plus System',
    to: '/simple-products/livescope-plus-lvs34',
    destination: 'standard_pdp',
    cta: 'see_standard_lvs34_system',
  },
  {
    id: 'lvs42hd-if',
    prompt: 'Considering LiveScope 2 ice instead?',
    label: 'See LVS42HD-IF',
    to: '/simple-products/livescope-2-lvs42hd-ice',
    destination: 'ice_variant',
    cta: 'see_lvs42hd_if',
  },
  {
    id: 'compatibility',
    prompt: 'Check your Garmin screen',
    label: 'Check compatibility',
    to: '/compatibility',
    destination: 'compatibility',
    cta: 'check_compatibility',
  },
]);

const PRICE_FIRST_PDP_COPY = Object.freeze({
  'garmin-lvs34': {
    displayTitle: 'Garmin LiveScope Plus LVS34 Transducer Only',
    secondaryIdentity: 'LVS34 · 010-02706-10',
    schemaName: 'Garmin LiveScope Plus LVS34 Transducer Only',
    documentTitle: 'Garmin LVS34 Transducer Only Price | Angler Built',
    orientation:
      'Replacement or upgrade LVS34 transducer for an existing GLS 10 sonar module. The GLS 10 black box and chartplotter are sold separately.',
    metaDescription:
      'Compare current verified prices for the Garmin LiveScope Plus LVS34 transducer only, part 010-02706-10. Requires a separate GLS 10 sonar module.',
    decisionEscapes: [
      {
        id: 'system',
        prompt: 'Need the GLS 10 black box too?',
        label: 'See the complete LiveScope Plus System',
        to: '/simple-products/livescope-plus-lvs34',
        destination: 'standard_pdp',
        cta: 'see_lvs34_system',
      },
      {
        id: 'compatibility',
        prompt: 'Check your Garmin screen',
        label: 'Check compatibility',
        to: '/compatibility',
        destination: 'compatibility',
        cta: 'check_compatibility',
      },
    ],
  },
  'livescope-2-lvs42hd': {
    displayTitle: 'Garmin LiveScope 2 HD Transducer',
    secondaryIdentity: 'LVS42HD',
    schemaName: 'Garmin LiveScope 2 HD Transducer LVS42HD',
    documentTitle: 'Garmin LiveScope 2 HD Transducer LVS42HD Price | Angler Built',
    orientation:
      'HD detail-focused LiveScope 2 transducer with a 125 ft rated range and direct connection to a compatible Garmin screen.',
    metaDescription:
      'Compare current verified retailer prices for Garmin LiveScope 2 LVS42HD, see when offers were checked, and find comparison and compatibility help from Angler Built.',
    decisionEscapes: LVS42HD_ESCAPES,
  },
  'livescope-2-lvs44': {
    displayTitle: 'Garmin LiveScope 2 Transducer',
    secondaryIdentity: 'LVS44',
    schemaName: 'Garmin LiveScope 2 Transducer LVS44',
    documentTitle: 'Garmin LiveScope 2 Transducer LVS44 Price | Angler Built',
    orientation:
      'Longer-range LiveScope 2 transducer with a 250 ft rated range, wider coverage, and direct connection to a compatible Garmin screen.',
    metaDescription:
      'Compare current verified retailer prices for Garmin LiveScope 2 LVS44, see when offers were checked, and find comparison and compatibility help from Angler Built.',
    decisionEscapes: LVS44_ESCAPES,
  },
  'livescope-2-lvs42hd-ice': {
    displayTitle: 'Garmin LiveScope 2 HD Ice Fishing Transducer',
    secondaryIdentity: 'LVS42HD-IF',
    schemaName: 'Garmin LiveScope 2 HD Ice Fishing Transducer LVS42HD-IF',
    documentTitle: 'Garmin LiveScope 2 HD Ice Fishing Transducer LVS42HD-IF | Angler Built',
    orientation:
      'Ice-focused LiveScope 2 HD transducer with the same 125 ft rated range as LVS42HD, plus a 9.8 ft flexible cold-weather cable and zero-degree ice shaft mount.',
    metaDescription:
      'Compare current verified retailer prices for Garmin LiveScope 2 LVS42HD-IF, see when offers were checked, and compare LiveScope 2 options or check compatibility with Angler Built.',
    decisionEscapes: LVS42HD_IF_ESCAPES,
  },
  'livescope-plus-lvs34': {
    displayTitle: 'Garmin LiveScope Plus System',
    secondaryIdentity: 'LVS34 + GLS 10',
    orientation:
      'Complete LiveScope Plus system with the LVS34 transducer and GLS 10 black box. Rated to 200 ft, and it requires the GLS 10 rather than connecting directly to the screen.',
    metaDescription:
      'Compare current verified retailer prices for the Garmin LiveScope Plus System with LVS34 and GLS 10, see when offers were checked, and compare upgrade or compatibility options with Angler Built.',
    decisionEscapes: LVS34_SYSTEM_ESCAPES,
  },
  'livescope-plus-lvs34-ice': {
    displayTitle: 'Garmin LiveScope Plus Ice Fishing System',
    secondaryIdentity: 'LVS34-IF + GLS 10',
    orientation:
      'Ice-focused LiveScope Plus system with the LVS34-IF transducer, cold-weather cable, and GLS 10 black box, rated to 200 ft.',
    metaDescription:
      'Compare current verified retailer prices for the Garmin LiveScope Plus Ice Fishing System with the LVS34-IF transducer and GLS 10, see when offers were checked, and compare the standard system or check compatibility with Angler Built.',
    decisionEscapes: LVS34_ICE_ESCAPES,
  },
});

export function isPriceFirstPdpSlug(slug) {
  return PRICE_FIRST_PDP_SLUGS.includes(String(slug || '').trim());
}

export function getPriceFirstPdpCopy(slug) {
  return PRICE_FIRST_PDP_COPY[String(slug || '').trim()] || null;
}

export function getCanonicalPdpOffers(offers) {
  if (!Array.isArray(offers)) return [];
  return offers.filter((offer) => offer && offer.isMergedRelatedOffer !== true);
}

export function formatPdpMsrpLabel(msrp) {
  const formatted = formatHeroCurrency(msrp);
  return formatted ? `MSRP ${formatted}` : null;
}

export function retailerOptionTestId(retailer) {
  return String(retailer || 'retailer')
    .toLowerCase()
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}
